import { Box } from "@mui/material";
import styles from './index.module.css'

const TabPanel = (props) => {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`vertical-tabpanel-${index}`}
            aria-labelledby={`vertical-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box className={styles.TabPadding}>
                    {children}
                </Box>
            )}
        </div>
    );
}
export default TabPanel;
